
export default {

  // Called by the host app to set the context in the grouper mfe
  /**
   *
   * @param data
   */
  setContext: function (data: InitData) {
    // TODO: actually do stuff with the initialization data
  },

  /**
   * placeholder for method host app will call to auto-add dx or procedure codes to the grouper
   * @param codes
   */
  addCodes: function (codes: any) {
    // TODO: implement add codes functionality
  },

  /**
   * called by MFE when a request is made to change the mode.  popup
   * @param popout
   */
  setMode: function (popout: boolean) {
    console.log(`Request to change to ${popout ? 'Popout' : 'Embedded'} mode`);
  },
};

export interface InitData {
  endpoint: string;
  facilityCode: string;
  visitId: number;
  dualGrouping: boolean;
}
